import { render, staticRenderFns } from "./OperaCreationApproveWindow.vue?vue&type=template&id=5b31de78&scoped=true&"
import script from "./OperaCreationApproveWindow.vue?vue&type=script&lang=js&"
export * from "./OperaCreationApproveWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaCreationApproveWindow.vue?vue&type=style&index=0&id=5b31de78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b31de78",
  null
  
)

export default component.exports